import React, { FC, useState } from 'react'
import { Loader } from '@/components/Loader'
import { OptGroup } from './OptGroup'
import { Header, Form, LoaderPlaceholder, Select } from './style'

interface ISelectForm {
  data: Array<{
    id: string | number,
    value: string,
    subOptions?: Array<{
      id: number
      value: string
    }>
  }> | undefined

  isLoading: boolean
  header?: string | React.ReactNode
  search?: boolean // ? если не определено свойство header, наличие search игнорируется
  disabled?: boolean
  onChange: (value: number) => void
}

export const SelectForm: FC<ISelectForm> = ({ data = [], isLoading, header, search, disabled, onChange }) => {
  const [filterQuery, setFilterQuery] = useState('')

  const filteredData = filterQuery
    ? data.filter(i => {
      const value = i.value.toLowerCase().trim()
      if (value.includes(filterQuery.toLowerCase())) {
        return i
      }
    })
    : data

  const changeSelectHandler = e => {
    onChange(+e.target.value)
  }

  const specialityFilter = e => {
    setFilterQuery(e.target.value)
  }

  return (
    <div>
      <Header>
        {header}
        {search &&
          <input type="text" className="form-control span2" onChange={specialityFilter} placeholder="поиск" />
        }
      </Header>
      <Form>
        {isLoading &&
          <LoaderPlaceholder>
            <Loader />
          </LoaderPlaceholder>
        }
        <Select className="form-control" size={10} name="speckod" id="speckod" onChange={changeSelectHandler} disabled={disabled || !data.length && !isLoading}>
          <option></option>

          {isLoading || disabled
            ? <option></option>
            : filteredData.map(i => (
              i.subOptions
                ? <OptGroup key={i.id} label={i.value} data={i.subOptions} />
                : <option key={i.id} value={i.id}>{i.value}</option>
            ))
          }

        </Select>
      </Form>
    </div>
  )
}


